import CommandService from '../../services/CommandService';
import { Command } from '../../models/Command';

export default {
  state: {},
  mutations: {},
  actions: {
    // Signal-only: QueueCommands subscribes and fetches commands locally
    getCommands(_context: any, _uid: number) {},

    // Signal-only actions for dialog control
    queueCommandsShow(_context: any) {},
    queueCommandsIridiumShow(_context: any) {},
    queueCommandsClose(_context: any) {},

    postCommand(context: any, command: Command) {
      CommandService.postCommand(command)
        .then(() => {
          context.dispatch('getCommands', command.uid);
          context.dispatch('notify', 'Queued command');
          context.dispatch('queueCommandsClose');
        })
        .catch((error: any) => {
          console.error(error);
          context.dispatch('notify', error);
        });
    },

    postCommands(context: any, commands: Command[]) {
      CommandService.postCommands(commands)
        .then(() => {
          context.dispatch('notify', 'Queued commands');
        })
        .catch((error: any) => {
          console.error(error);
          context.dispatch('notify', error);
        });
    },
  },
};
